var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWaitingTranslator = function SvgWaitingTranslator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#87AACA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.053 4.75a2.333 2.333 0 1 0 0 4.667H9.47A4.083 4.083 0 0 0 5.387 13.5c0 .644.522 1.167 1.166 1.167h7c.645 0 1.167-.523 1.167-1.167a4.083 4.083 0 0 0-4.083-4.083h-.584a2.333 2.333 0 0 0 0-4.667ZM8.887 7.083a1.167 1.167 0 1 1 2.333 0 1.167 1.167 0 0 1-2.333 0ZM6.553 13.5a2.917 2.917 0 0 1 2.917-2.917h1.167a2.917 2.917 0 0 1 2.916 2.917h-7Z",
    clipRule: "evenodd"
  })));
};
export default SvgWaitingTranslator;